import React from 'react';
import { StandardProps } from '@/newcar/ui/contract';
import { ContractType } from '@/newcar/util/const/contract';
import step2 from '@/newcar/ui/contract/img/step-2-done-bar.svg';
import step3 from '@/newcar/ui/contract/img/step-2-done-bar-text.svg';

interface StepProps extends StandardProps {
  type: ContractType;
}

const Picture: {
  [Key in ContractType]: string;
} = {
  contact_info: '',
  personal_info: step2,
  review_info: step3,
  provisional_completion: '',
};

export default function Step(props: StepProps): JSX.Element {
  const {
    type,
    className = '',
  } = props;

  if (type === 'contact_info' || type === 'provisional_completion') return <></>;
  return (
    <div className="has-background-white has-text-centered" id="step-icon">
      <picture>
        <div className="is-padding-top-1">
          <img className={className} src={Picture[type]} alt="" />
        </div>
      </picture>
    </div>
  );
}
